/* Alchemy - drifting golden sparkles (left to right): page background + header */
(function () {
  if (window.__alcParticles) return;
  window.__alcParticles = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COLORS = ['255,240,184', '243,210,122', '212,175,55', '230,192,101'];
  var sprites = COLORS.map(function (rgb) {
    var s = document.createElement('canvas'), r = 32;
    s.width = s.height = r * 2;
    var g = s.getContext('2d');
    var grad = g.createRadialGradient(r, r, 0, r, r, r);
    grad.addColorStop(0, 'rgba(255,252,235,1)');
    grad.addColorStop(0.12, 'rgba(' + rgb + ',0.95)');
    grad.addColorStop(0.35, 'rgba(' + rgb + ',0.35)');
    grad.addColorStop(1, 'rgba(' + rgb + ',0)');
    g.fillStyle = grad;
    g.fillRect(0, 0, r * 2, r * 2);
    return s;
  });
  function rand(a, b) { return a + Math.random() * (b - a); }

  function Field(canvas, sizeFn, density, maxCount, minCount, scale) {
    this.c = canvas; this.ctx = canvas.getContext('2d');
    this.sizeFn = sizeFn; this.density = density; this.max = maxCount; this.min = minCount;
    this.scale = scale || 1; this.parts = []; this.W = 0; this.H = 0;
    this.resize();
  }
  Field.prototype.spawn = function (p, anywhere) {
    var d = Math.random();
    p.d = d;
    p.size = (2 + d * 9) * this.scale;
    p.vx = 0.035 + d * 0.13;
    p.vy = rand(-0.025, 0.025);
    p.wob = rand(0.0004, 0.0012);
    p.wamp = rand(3, 14) * this.scale;
    p.ph = rand(0, Math.PI * 2);
    p.tw = rand(0.0012, 0.0035);
    p.base = 0.25 + d * 0.55;
    p.sp = sprites[(Math.random() * sprites.length) | 0];
    p.x = anywhere ? rand(0, this.W) : rand(-40, -10);
    p.y0 = rand(0, this.H);
    return p;
  };
  Field.prototype.resize = function () {
    var dpr = Math.min(window.devicePixelRatio || 1, 2), sz = this.sizeFn();
    this.W = sz[0]; this.H = sz[1];
    this.c.width = this.W * dpr; this.c.height = this.H * dpr;
    this.c.style.width = this.W + 'px'; this.c.style.height = this.H + 'px';
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var target = Math.round(Math.min(this.max, Math.max(this.min, (this.W * this.H) / this.density)));
    while (this.parts.length < target) this.parts.push(this.spawn({}, true));
    this.parts.length = target;
  };
  Field.prototype.draw = function (now, dt) {
    var ctx = this.ctx, W = this.W, H = this.H;
    ctx.clearRect(0, 0, W, H);
    ctx.globalCompositeOperation = 'lighter';
    for (var i = 0; i < this.parts.length; i++) {
      var p = this.parts[i];
      p.x += p.vx * dt;
      p.y0 += p.vy * dt;
      if (p.y0 < -20) p.y0 = H + 10; else if (p.y0 > H + 20) p.y0 = -10;
      var y = p.y0 + Math.sin(now * p.wob + p.ph) * p.wamp;
      var tw = 0.5 + 0.5 * Math.sin(now * p.tw + p.ph * 3);
      var a = p.base * (0.25 + 0.75 * tw * tw);
      if (p.x > W + 40) { this.spawn(p, false); continue; }
      ctx.globalAlpha = a;
      var s = p.size * (0.8 + 0.4 * tw);
      ctx.drawImage(p.sp, p.x - s, y - s, s * 2, s * 2);
      if (p.d > 0.75 && tw > 0.92) {
        ctx.globalAlpha = a * 0.6;
        ctx.fillStyle = 'rgba(255,245,200,1)';
        ctx.fillRect(p.x - s * 1.6, y - 0.5, s * 3.2, 1);
        ctx.fillRect(p.x - 0.5, y - s * 1.6, 1, s * 3.2);
      }
    }
    ctx.globalAlpha = 1;
  };

  var fields = [];

  var bg = document.createElement('canvas');
  bg.id = 'alc-particles';
  bg.setAttribute('aria-hidden', 'true');
  document.body.insertBefore(bg, document.body.firstChild);
  fields.push(new Field(bg, function () { return [window.innerWidth, window.innerHeight]; }, 16000, 110, 35, 1));

  var hw = document.querySelector('.header-wrapper');
  if (hw) {
    var hc = document.createElement('canvas');
    hc.className = 'alc-header-particles';
    hc.setAttribute('aria-hidden', 'true');
    hw.insertBefore(hc, hw.firstChild);
    fields.push(new Field(hc, function () { return [hw.clientWidth, hw.clientHeight]; }, 3500, 40, 10, 0.8));
  }

  var last = performance.now();
  function frame(now) {
    var dt = Math.min(50, now - last) / 16.67; last = now;
    for (var i = 0; i < fields.length; i++) fields[i].draw(now, dt);
    if (!reduce) requestAnimationFrame(frame);
  }
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { fields.forEach(function (f) { f.resize(); }); }, 150);
  });
  requestAnimationFrame(frame);
})();
